import {PAGE_NAME, STATUS_BAR_COLOR} from '@/shared/constants/statusBarColor';

import CardDeletePage from '@/apps/root/components/CardDeletePage';

const CardGroupDeletePage = () => {
  return (
    <CardDeletePage
      statusBarColor={{
        default: STATUS_BAR_COLOR[PAGE_NAME.DEFAULT],
        unmount: STATUS_BAR_COLOR[PAGE_NAME.CARD_GROUP]
      }}
    />
  );
};

export default CardGroupDeletePage;
